import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export interface IFormulaireProps {
    valueModule: any;
    setValueModule: any;
}

const Formulaire = (props: IFormulaireProps) => {


    const {
        valueModule,
        setValueModule
    } = props



    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Module"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueModule"
                        value={valueModule}
                        onChange={(e) => setValueModule(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default Formulaire;
